import React, {useRef, useState, useEffect} from "react";
import blueBg from "../../resources/images/utils/blue.png";
import purpleBg from "../../resources/images/utils/purple.png";
import {
  Container,
  HalfColumn,
  Heading,
  ImageItem,
  List,
  Text,
  ThemeWrapper,
} from "../../styled";
import {
  blackColor,
  disabledColor,
  greyTextColor,
  lightSecondColor,
  orangeColor,
  questionTextColor,
} from "../../constants/colors";
import {PreLandBlock} from "./styled";
import Logo from "../design_components/Logo/Logo";
import {useSelector, useDispatch} from "react-redux";
import fdaIcon from "./../../resources/images/icons/FDA_logo.png";
import {
  data,
  ONBOARDING_ID,
  ONBOARDING_ID_GOOGLE,
  ONBOARDING_ID_FB,
  LANDING_ID,
  LANDING_ID_FB,
  LANDING_ID_GOOGLE,
  pre_land_list,
  pre_land_list_second,
  pre_land_spoilers,
  pre_land_top_icon_list_second,
  preland_items,
  pre_landing_google_link
} from "../../constants/data";
import bird from "../../resources/images/icons/bird_white.svg";
import Button from "../design_components/Button/Button";
import Tooltip from "../design_components/Info/Info";
import {useHistory} from "react-router";
import {HOME_ROUTE} from "../../constants/routes";
import {useContainerWidth} from "../../hooks/useContainerWidth";
import cdcIcon from "./../../resources/images/icons/CDC_logo.png";
import bullet from "./../../resources/images/icons/orange_bullet.svg";
import girlImg from "./../../resources/images/preLand/girl.png";
import blanketImg from "./../../resources/images/preLand/blanket.png";
import arrowImg from "./../../resources/images/preLand/arrow.png";
import phoneImg from "./../../resources/images/preLand/phone.png";
import bottomPhoneImg from "./../../resources/images/preLand/bottom_phone.png";
import graphImg from "./../../resources/images/preLand/graph.png";
import {pre_land_top_icon_list} from "../../constants/data";
import {PrepaywallBlock} from "../Prepaywall/styled";
import doc1img from "../../resources/images/prePaywall/doc_1.png";
import yaleimg from "../../resources/images/preLand/yale.png";
import doc2img from "../../resources/images/prePaywall/doc_2.png";
import healthimg from "../../resources/images/preLand/health.png";
import previevImg from "../../resources/images/preLand/preview@3x.png";
import playImg from "../../resources/images/icons/play_b.png";
import video from "../../resources/images/preLand/Testimonal.mp4";
import Spoiler from "../design_components/Spoiler/Spoiler";
import {
  landingCompleteEventAmplitude,
  landingOpenEventAmplitude,
} from "../../amplitude/events";
import {
  analyticsInitFunction,
  analyticsSetFunction,
  createEventObjectFunction,
  checkWebDevice,
  checkOsVersion,
  redirectToStoreFunction,
  getGeoInfo,
  encodeCity
} from "../../utils/helper";
import {setAnalyticsInit} from "../../store/questions/actions";
import {
  landingCompleteEvent,
  landingOpenEvent,
} from "../../firebaseAnalytics/events";
import {analytics} from "../../firebaseAnalytics";


const PreLand = () => {
  const remoteConfig = useSelector((state) => state.questions.remoteConfig);
  const dispatch = useDispatch();
  const history = useHistory();

  const containerRef = useRef(null);
  const videoRef = useRef(null);

  const [isVideoPlay, setVideoPlay] = useState(false);
  const [user, setUser] = useState(null);
  const [eventObject, setEventObject] = useState({});
  const [fixedButtonVisible, setFixedButtonVisible] = useState(false);

  const [userGeoInfo, setUserGeoInfo] = useState(null)

  const url = window.location.href;
  const params = new URL(url).searchParams;

  const [onboardingId] = useState(() => {
    switch (params.get('type')) {
      case 'google':
        return ONBOARDING_ID_GOOGLE;
      case 'fb':
        return ONBOARDING_ID_FB;
      default:
        return ONBOARDING_ID;
    }
  })

  const [landingId] = useState(() => {
    switch (params.get('type')) {
      case 'google':
        return LANDING_ID_GOOGLE;
      case 'fb':
        return LANDING_ID_FB;
      default:
        return LANDING_ID;
    }
  })

  const [btnTitle] = useState(() => {
    switch (params.get('type')) {
      case 'fb':
        return 'Try Journey'
      default:
        return 'Start Assessment';
    }
  })

  useEffect(() => {
    setGeoInfo()
  }, [])

  useEffect(() => {
    if (
        Object.keys(remoteConfig).length &&
        Object.keys(remoteConfig.experiments).length
    ) {
      analyticsInitFunction(remoteConfig);
      analyticsSetFunction(
          setUser,
          setEventObject,
          eventObject,
          landingId,
          onboardingId,
          checkWebDevice(),
          checkOsVersion()
      );
      dispatch(setAnalyticsInit(true));
      dispatch(setAnalyticsInit(true));
      const eventObj = createEventObjectFunction(
          null,
          onboardingId,
          landingId
      );
      landingOpenEventAmplitude(eventObj);
      landingOpenEvent(analytics, eventObj);
    }
  }, [remoteConfig]);

  useEffect(() => {
    window.addEventListener("scroll", calculateButtonView);
    return () => window.removeEventListener("scroll", calculateButtonView);
  }, []);

  const setGeoInfo = async () => {
    const geoInfoRes = await getGeoInfo()
    setUserGeoInfo(geoInfoRes)
  }

  const handleButtonClick = () => {
    landingCompleteEventAmplitude(eventObject);
    landingCompleteEvent(analytics, eventObject);
    setTimeout(() => {
      switch (params.get('type')) {
        case 'google':
          window.location.href = pre_landing_google_link
          break;
        case 'fb':
          redirectToStoreFunction(true, encodeCity(userGeoInfo.city), userGeoInfo.region_code.toLocaleLowerCase(), userGeoInfo.postal, userGeoInfo.country_code.toLocaleLowerCase())
          break;
        default:
          history.push(HOME_ROUTE);
      }
    }, 350);
  };

  const calculateButtonView = () => {
    if (window.scrollY > window.innerHeight) {
      setFixedButtonVisible(true);
    } else {
      setFixedButtonVisible(false);
    }
  };

  const itemRenderFunction = (item) => {
    return (
        <List.Item key={`${item.id}-item`}>
          <List.Item.Bullet bullet={bullet}/>
          <List.Item.Text>
            <Text.Fourth
                style={{
                  marginBottom: 19,
                  textAlign: "left",
                  color: disabledColor,
                }}
            >
            <span>
              <span>{item.text}</span>
              <Tooltip
                  opacity={0.36}
                  translateX={-20}
                  width={
                    containerRef.current
                        ? useContainerWidth(containerRef.current)
                        : 100
                  }
                  message={item.messageText}
              />
            </span>
            </Text.Fourth>
          </List.Item.Text>
        </List.Item>
    );
  };

  const renderTopContent = () => {
    return (
        <PreLandBlock.Top>
          <ThemeWrapper style={{paddingBottom: 37}} bgColor={blackColor}>
            <img className="blue" src={blueBg} alt="bg"/>
            <img className="purple" src={purpleBg} alt="bg"/>
            <Container.Content ref={containerRef}>
              <div style={{marginBottom: 40}}>
                <Logo
                    type="preland"
                    text={"Digital Sleep Coach"}
                    link={remoteConfig.storeLink}
                />
              </div>
              <Heading.Third
                  style={{
                    textAlign: "left",
                    color: questionTextColor,
                    paddingRight: 50,
                    marginBottom: 6,
                  }}
              >
                Improve your sleep quality in 6 weeks without pills
              </Heading.Third>
              <img
                  src={fdaIcon}
                  alt="Fda"
                  style={{width: 77, position: "absolute", right: 0, top: 40}}
              />
              <Text.Fourth
                  style={{
                    marginBottom: 17,
                    textAlign: "left",
                    color: greyTextColor,
                  }}
              >
                Based on the latest research and backed up by CBT (cognitive
                behavioral therapy) methods Journey app can help you improve your
                sleep with a personalized program:
              </Text.Fourth>
              <Container.Items
                  style={{marginBottom: 30}}
                  bgColor={"rgba(53, 48, 120, 0.2);"}
                  border={"border: 2px solid rgba(236, 235, 255, 0.1);"}
              >
                {pre_land_list.map((item) => {
                  return (
                      <ImageItem
                          key={`${item.id}-prepaywall-data`}
                          style={{
                            marginBottom:
                                item.id === pre_land_list.length - 1 ? 0 : 19,
                          }}
                      >
                        <ImageItem.Img
                            style={{
                              width: 22,
                              height: 22,
                              minWidth: 22,
                              marginRight: 10,
                              boxShadow: "none",
                              background: "#5DB574",
                            }}
                        >
                          <img src={bird} alt="bird"/>
                        </ImageItem.Img>
                        <ImageItem.Text style={{minHeight: "auto"}}>
                          <Text.Fourth
                              dangerouslySetInnerHTML={item.text}
                              style={{
                                color: greyTextColor,
                                textAlign: "left",
                              }}
                          />
                        </ImageItem.Text>
                      </ImageItem>
                  );
                })}
              </Container.Items>
              <Button
                  type={"default"}
                  isGradient={true}
                  text={btnTitle}
                  action={() => handleButtonClick()}
                  style={{marginBottom: 40}}
              />
              <Heading.Third
                  style={{
                    textAlign: "left",
                    color: questionTextColor,
                    marginBottom: 6,
                  }}
              >
                <span>Don’t get enough sleep?</span>
                <br/>
                <span style={{color: orangeColor}}>You are not alone.</span>
              </Heading.Third>
              <Text.Fourth
                  style={{
                    marginBottom: 19,
                    textAlign: "left",
                    color: greyTextColor,
                  }}
              >
              <span>
                <span>
                  35% of U.S. adults are not getting the recommended 7 hours of
                  sleep each night.
                </span>
                <Tooltip
                    opacity={0.76}
                    width={
                      containerRef.current
                          ? useContainerWidth(containerRef.current)
                          : 100
                    }
                    message={"Centers for Disease Control and Prevention, 2016"}
                />
              </span>
              </Text.Fourth>
              <img
                  src={girlImg}
                  alt="girl"
                  style={{width: 150, margin: "0 auto"}}
              />
            </Container.Content>
          </ThemeWrapper>
          <img
              src={blanketImg}
              alt="blanket"
              style={{
                width: "100%",
                height: 53,
                top: -80,
                position: "relative",
                margin: "0 auto",
              }}
          />
        </PreLandBlock.Top>
    );
  };

  const renderCenterContent = () => {
    return (
        <Container.Content>
          <PreLandBlock.Center.Title>
            <Heading.Fifth
                style={{
                  textAlign: "left",
                  color: blackColor,
                  width: 200,
                }}
            >
              A good night’s sleep is critical for good health.
            </Heading.Fifth>
            <img style={{width: 60}} src={cdcIcon} alt="cdc"/>
          </PreLandBlock.Center.Title>
          <Text.Fourth
              style={{
                marginBottom: 25,
                textAlign: "left",
                color: disabledColor,
              }}
          >
          <span>
            <span>
              Adults over 50 need 7-9 hours of sleep. Sleeping less than 7 hours per day is associated with an increased risk of developing chronic conditions such as obesity, diabetes, high blood pressure, heart disease, stroke, and frequent mental distress.
            </span>
            <Tooltip
                opacity={0.36}
                width={
                  containerRef.current
                      ? useContainerWidth(containerRef.current)
                      : 100
                }
                message={
                  "Watson NF, Badr MS, Belenky G, et al. Recommended amount of sleep for a healthy adult: a joint consensus statement of the American Academy of Sleep Medicine and Sleep Research Society. Sleep 2015;38:843–4."
                }
            />
          </span>
          </Text.Fourth>
          {preland_items.map((item) => {
            return itemRenderFunction(item);
          })}
        </Container.Content>
    );
  };

  const renderPhoneBlock = () => {
    return (
        <PreLandBlock.Phone>
          <Container.Content>
            <Heading.Third
                style={{
                  textAlign: "left",
                  color: questionTextColor,
                  marginBottom: 6,
                }}
            >
            <span>
              You are capable of getting refreshing, energizing, and restorative sleep
            </span>
              <br/>
              <span style={{position: "relative"}}>
              <span style={{color: orangeColor}}>
                And we are here to help.
              </span>
              <span style={{position: "absolute", right: -50, top: 7}}>
                <img src={arrowImg} alt="arrow" style={{width: 42}}/>
              </span>
            </span>
            </Heading.Third>
          </Container.Content>
          <PreLandBlock.Phone.Img>
            <img
                src={phoneImg}
                alt="phone"
                style={{maxWidth: 375, margin: "0 auto"}}
            />
            <PreLandBlock.Phone.Gradient/>
          </PreLandBlock.Phone.Img>

          <div
              style={{
                paddingTop: 46,
                paddingBottom: 24,
                background: blackColor,
              }}
          >
            <Container.Content>
              {columnItemsRender(pre_land_top_icon_list, greyTextColor, 160)}
            </Container.Content>
          </div>
        </PreLandBlock.Phone>
    );
  };

  const renderImproveBlock = () => {
    return (
        <>
          <Container.Content>
            <Heading.Third
                style={{
                  textAlign: "left",
                  color: blackColor,
                  marginBottom: 6,
                }}
            >
              Improve your sleep in 6 weeks
            </Heading.Third>
            <Text.Fourth
                style={{
                  textAlign: "left",
                  color: disabledColor,
                  marginBottom: 10,
                }}
            >
              We use cognitive behavioural therapy methods recommended by the
              American College of Physicians as a first-line approach
            </Text.Fourth>
            <img src={graphImg} alt="graph" style={{width: "100%"}}/>
            <Text.Eight
                style={{
                  textAlign: "center",
                  color: disabledColor,
                  marginBottom: 35,
                  textTransform: "none",
                  letterSpacing: 0,
                }}
            >
              70% of people using digital CBT improve their sleep quality within 6
              weeks (PubMed research, January 2019)
            </Text.Eight>
            <Heading.Third
                style={{
                  color: blackColor,
                  marginBottom: 26,
                }}
            >
              You have not lost the ability to fall asleep or fall back to sleep.
            </Heading.Third>
            <Heading.Fifth style={{color: disabledColor, marginBottom: 16}}>
              You will:
            </Heading.Fifth>
            {columnItemsRender(pre_land_top_icon_list_second, disabledColor, 100)}
          </Container.Content>
        </>
    );
  };

  const renderDocsBlock = () => {
    return (
        <Container.Content>
          <PrepaywallBlock.Docs>
            <PrepaywallBlock.Doc>
              <img src={doc1img} alt="doc"/>
              <img src={yaleimg} alt="doc"/>
            </PrepaywallBlock.Doc>
            <PrepaywallBlock.Doc>
              <img src={doc2img} alt="doc"/>
              <img src={healthimg} alt="doc"/>
            </PrepaywallBlock.Doc>
          </PrepaywallBlock.Docs>
        </Container.Content>
    );
  };

  const handlePlayClick = () => {
    setVideoPlay(true);
  };

  useEffect(() => {
    if (isVideoPlay === true) {
      videoRef.current.play();
    }
  }, [isVideoPlay]);

  useEffect(() => {
    videoRef.current.addEventListener("pause", onVideoPause);
    return () => videoRef.current.removeEventListener("pause", onVideoPause);
  }, []);

  const onVideoPause = () => {
    setVideoPlay(false);
  };

  const renderBottomBlock = () => {
    return (
        <>
          <PreLandBlock.Phone style={{backgroundPosition: "bottom"}}>
            <Container.Content>
              <Heading.Third
                  style={{
                    textAlign: "left",
                    color: questionTextColor,
                    marginBottom: 6,
                  }}
              >
                What to expect from
                <br/>
                Journey app
              </Heading.Third>
            </Container.Content>
            <PreLandBlock.Phone.Img>
              <img
                  src={bottomPhoneImg}
                  alt="phone"
                  style={{maxWidth: 375, margin: "0 auto"}}
              />
            </PreLandBlock.Phone.Img>
          </PreLandBlock.Phone>
          <Container.Content>
            <Heading.Third
                style={{
                  textAlign: "left",
                  color: questionTextColor,
                  marginBottom: 17,
                  // marginTop: 60,
                }}
            >
              Your Sleep Plan Includes:
            </Heading.Third>
            <Container.Items
                style={{marginBottom: 40}}
                bgColor={"rgba(53, 48, 120, 0.2);"}
                border={"border: 2px solid rgba(236, 235, 255, 0.1);"}
            >
              {pre_land_list_second.map((item) => {
                return (
                    <ImageItem
                        key={`${item.id}-prepaywall-data-second`}
                        style={{
                          marginBottom:
                              item.id === pre_land_list_second.length - 1 ? 0 : 19,
                        }}
                    >
                      <ImageItem.Img
                          style={{
                            width: 22,
                            height: 22,
                            minWidth: 22,
                            marginRight: 10,
                            boxShadow: "none",
                            background: "#5DB574",
                          }}
                      >
                        <img src={bird} alt="bird"/>
                      </ImageItem.Img>
                      <ImageItem.Text style={{minHeight: "auto"}}>
                        <Text.Fourth
                            dangerouslySetInnerHTML={item.text}
                            style={{
                              color: greyTextColor,
                              textAlign: "left",
                            }}
                        />
                      </ImageItem.Text>
                    </ImageItem>
                );
              })}
            </Container.Items>
            <Heading.Third
                style={{
                  textAlign: "left",
                  color: questionTextColor,
                  marginBottom: 17,
                }}
            >
              Life-changing results that last
            </Heading.Third>
            <PreLandBlock.Video style={{marginBottom: 40}}>
              <PreLandBlock.Video.Content
                  style={{opacity: !isVideoPlay ? 1 : 0}}
                  onClick={handlePlayClick}
              >
                <PreLandBlock.Video.Left>
                  <img src={playImg} alt="play"/>
                  <Text.Comment
                      style={{
                        fontSize: 20,
                        lineHeight: "26px",
                        color: lightSecondColor,
                        textAlign: "left",
                      }}
                  >
                    <span style={{fontWeight: 800}}>We asked people</span>
                    <br/>
                    <span>how Journey helps them.</span>
                  </Text.Comment>
                </PreLandBlock.Video.Left>
                <PreLandBlock.Video.Right>
                  <img src={previevImg} alt="preview"/>
                </PreLandBlock.Video.Right>
              </PreLandBlock.Video.Content>
              <PreLandBlock.Video.Player
                  style={{
                    opacity: isVideoPlay ? 1 : 0,
                    zIndex: isVideoPlay ? 1 : -1,
                  }}
              >
                <video ref={videoRef}>
                  <source src={video} type="video/mp4"/>
                </video>
              </PreLandBlock.Video.Player>
            </PreLandBlock.Video>
            <Heading.Third
                style={{
                  textAlign: "left",
                  color: questionTextColor,
                  marginBottom: 17,
                }}
            >
              FAQ
            </Heading.Third>
            <PreLandBlock.Spoilers style={{paddingBottom: 80}}>
              {pre_land_spoilers.map((spoiler, index) => {
                return (
                    <Spoiler
                        key={`${spoiler.id}-spoiler`}
                        spoilerData={spoiler}
                        remoteConfig={remoteConfig}
                        style={{marginBottom: 10}}
                        isOpen={index === 0}
                    />
                );
              })}
            </PreLandBlock.Spoilers>
          </Container.Content>
        </>
    );
  };

  const columnItemsRender = (items, textColor, maxTextWidth) => {
    return (
        <HalfColumn>
          {items.map((item) => {
            return (
                <HalfColumn.Item key={`${item.id}-preland-first`}>
                  <HalfColumn.Item.Icon>
                    <img
                        src={item.icon}
                        alt={item.text}
                        style={{width: 70, height: 70}}
                    />
                  </HalfColumn.Item.Icon>
                  <HalfColumn.Item.Text>
                    <Text.Fifth
                        style={{
                          lineHeight: "18px",
                          color: textColor,
                          maxWidth: maxTextWidth,
                        }}
                    >
                      {item.text}
                    </Text.Fifth>
                  </HalfColumn.Item.Text>
                </HalfColumn.Item>
            );
          })}
        </HalfColumn>
    );
  };

  return (
      <PreLandBlock>
        {renderTopContent()}
        <PreLandBlock.Center
            style={{marginTop: -88, background: "#e0dff0", position: "relative"}}
        >
          {renderCenterContent()}
        </PreLandBlock.Center>
        <PreLandBlock.Block backgroundColor={blackColor}>
          {renderPhoneBlock()}
        </PreLandBlock.Block>
        <PreLandBlock.Block
            backgroundColor={"#E0DFF0"}
            style={{paddingTop: 34, paddingBottom: 20}}
        >
          {renderImproveBlock()}
        </PreLandBlock.Block>
        <PreLandBlock.Block
            backgroundColor={"#3C3689"}
            style={{paddingTop: 52, paddingBottom: 54}}
        >
          {renderDocsBlock()}
        </PreLandBlock.Block>
        <PreLandBlock.Block backgroundColor={blackColor}>
          {renderBottomBlock()}
        </PreLandBlock.Block>
        {fixedButtonVisible ? (
            <div
                style={{
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  paddingLeft: 20,
                  paddingRight: 20,
                  paddingBottom: 20,
                  zIndex: 2,
                  boxSizing: "border-box",
                }}
            >
              <Button
                  type={"default"}
                  isGradient={true}
                  text={btnTitle}
                  action={() => handleButtonClick()}
              />
            </div>
        ) : null}
      </PreLandBlock>
  );
};

export default PreLand;
